export default {
      id: "map__car_type_law-men-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_law-men",
      toString: function () {
        return this.url;
      }
    }